export const data = 
    
    [

    { id: 1,  name: 'Batman' },
    { id: 2,  name: 'Spiderman' },
    { id: 3, name: 'Iron Man '},
    { id: 4, name: 'Superman'},

];

 